import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  deleteApiV2CustomersCustomerIdProductRatingsId,
  type Params,
} from '@hungryroot/rest/api/v2/customers/[id]/product_ratings/[id]/delete';

type UseDeleteCustomerProductRatingProps<Context> = Omit<
  UseMutationOptions<void, Error, Params, Context>,
  'mutationFn'
>;

export function useDeleteCustomerProductRating<Context>(
  props?: UseDeleteCustomerProductRatingProps<Context>
) {
  return useMutation({
    mutationFn: async (params: Params) => {
      const res = await deleteApiV2CustomersCustomerIdProductRatingsId(params);

      if (res.status !== StatusCode.SuccessNoContent) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      return res.data;
    },
    ...props,
  });
}
